export enum AwareMediaUploadSource {
    library,
    direct,
}
